/*
 * Copyright (c) 2020 Honeywell International, Inc. All rights reserved.
 *
 * This file contains trade secrets of Honeywell International, Inc.  No part
 *  may be reproduced or transmitted in any form by any means or for any
 *  purpose without the express written permission of Honeywell.
 *
 */
import React from 'react';
import {AbstractWizardState} from "./AbstractWizardState";
import {ContactSupport} from "../common/ContactSupport";
import DIYGatewayManagement from "../DIYGatewayManagement";

/**
 * This represents the state transition to Contact Support page
 */
export class ContactSupportState extends AbstractWizardState {

  constructor(page: DIYGatewayManagement, prevState: AbstractWizardState) {
    super(page);
    this.prevState = prevState;
  }

  /**
   * Returns the Contact Support page
   * @returns {JSX.Element}
   */
  getContent(): JSX.Element {
    // Read these variables from octopus ??
    let envVariables = this.page.props.globalStore!.envVariables;
    let phNumbers = (envVariables.SUPPORT_PHONE_NUMBERS && envVariables.SUPPORT_PHONE_NUMBERS.split(',')) || [];
    return <ContactSupport supportEmail={envVariables.SUPPORT_EMAIL_ID}
                           supportPhoneNumbers={phNumbers}
                           onClose={() => {
                             this.navigateToPreviousComponent();
                           }}/>;
  }

  /**
   * Navigate to the previous page from where the contact support was called
   */
  navigateToPreviousComponent = () => {
    this.page.setState({
      registrationStatus: this.prevState
    })
  }

  private prevState: AbstractWizardState;
}
